import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const SetUpDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between lg:ml-[600px]">
        <h1 className="flex items-center justify-center text-3xl font-extrabold">
          SETUP
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>
      <div className="grid lg:grid-cols-4 grid-cols-1 gap-4 mt-5 lg:ml-0 ml-10">
        <div
          className="w-[300px] h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/ComplianceChecklist");
          }}
        >
          <h3>Compliance Checklist</h3>
        </div>
        <div
          className="w-[300px] h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/TaskMaster");
          }}
        >
          <h3>Task Master</h3>
        </div>
        <div
          className="w-[300px] h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/GateMaster");
          }}
        >
          <h3>Gate Master</h3>
        </div>
        <div
          className="w-[300px] h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/WeighbridgeMaster");
          }}
        >
          <h3>Weighbridge Master</h3>
        </div>
      </div>
    </div>
  );
};

export default SetUpDashboard;
